import { CENTERS } from '@/common/types/centers';

/** Clinic freeturn-error sheet support contact — allowlisted doctor slugs only. */
export const MMDP24_CLINIC_SUPPORT_SLUGS = [
  'دکتر-عبدالمجید-طاهری-0',
  'دکتر-آزیتا-کبیری-2',
  'دکتر-پدرام-بابائی-1',
  'دکتر-راحله-نامداربابلی',
  'دکتر-علی-حاذقی',
  'دکتر-رضا-خسروی-راستابی-1',
  'دکتر-الهام-زارعان-0',
  'دکتر-شیرین-موذن-دهکردی',
  'دکتر-علی-اصیلیان',
  'دکتر-سعید-نوروزی-0',
  'دکتر-علی-ابراهیمی-8',
  'دکتر-همایون-سخنور-0',
  'دکتر-مرضیه-طالبیان-2',
] as const;

/** @deprecated use MMDP24_CLINIC_SUPPORT_SLUGS */
export const MMDP24_CLINIC_SUPPORT_SLUG = MMDP24_CLINIC_SUPPORT_SLUGS[0];

export const MMDP24_BALE_URL = 'https://ble.ir/MMDP24';

const supportSlugSet = new Set<string>(MMDP24_CLINIC_SUPPORT_SLUGS);

export function normalizeBookingSlug(slug: string | undefined | null): string {
  const raw = slug ?? '';
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

/** True only for allowlisted doctors on a non-consult (clinic) center. */
export function shouldShowMmdpClinicSupport(
  slug: string | undefined | null,
  centerId: string | number | undefined | null,
): boolean {
  if (centerId == null || centerId === '') return false;
  if (String(centerId) === CENTERS.CONSULT) return false;
  return supportSlugSet.has(normalizeBookingSlug(slug));
}
